/* Curated links render in Liquid. This adds newly published, classified articles. */
(() => {
  const root = document.querySelector('.sgc[data-cluster]');
  if (!root || root.dataset.discovery) return;
  root.dataset.discovery = 'loading';
  const prefix = window.Shopify?.routes?.root || '/';
  const existing = new Set([...root.querySelectorAll('.sgc__art')].map(a => new URL(a.href).pathname));
  const cluster = root.dataset.cluster;
  const slug = cluster.replace(/^slaapgids-/, '');
  const rows = [...root.querySelectorAll('[data-subtags]')];
  const alleenEigen = 'alleenEigen' in root.dataset;
  const el = (tag, cls, text) => { const node = document.createElement(tag); node.className = cls; if (text) node.textContent = text; return node; };
  async function feed(blog) {
    let url = new URL(prefix + 'blogs/' + blog + '?view=sg2-feed', location.origin);
    const seen = new Set(), items = [];
    while (url) {
      if (url.origin !== location.origin || seen.has(url.href)) throw new Error('Invalid Slaapgids pagination');
      seen.add(url.href);
      const response = await fetch(url, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Slaapgids feed: ' + response.status);
      const data = await response.json();
      if (!Array.isArray(data.items)) throw new Error('Invalid Slaapgids feed');
      items.push(...data.items);
      url = data.next ? new URL(data.next, location.origin) : null;
      if (url) url.searchParams.set('view', 'sg2-feed');
    }
    return items;
  }
  async function update() {
    const items = [];
    // Sequential requests avoid bursts when a blog contains multiple pages.
    for (const blog of ['advies', 'slaapproblemen', 'matras-educatie']) items.push(...await feed(blog));
    items.sort((a, b) => Number(b.published) - Number(a.published));
    let extra;
    for (const item of items) {
      const tags = item.tags || [];
      if (item.cluster !== cluster && !tags.includes('thema-' + slug) && !tags.includes('cluster:' + slug)) continue;
      if (alleenEigen && item.cluster && item.cluster !== cluster) continue;
      const url = new URL(item.url, location.origin);
      if (url.origin !== location.origin || !url.pathname.startsWith(prefix + 'blogs/') || existing.has(url.pathname)) continue;
      const past = r => r.dataset.subtags.split('|').some(tag => tag && tags.includes(tag));
      const row = rows.find(r => 'voorrang' in r.dataset && past(r)) || rows.find(past);
      let grid = row?.querySelector('.sgc__art-grid');
      if (!grid) {
        if (!extra) {
          extra = el('section', 'sgc__wrap sgc__sectie');
          extra.append(el('h2', 'sgc__kop', 'Meer binnen dit thema'));
          const holder = el('div', 'sgc__art-grid'); holder.style.marginTop = '20px'; extra.append(holder);
          root.querySelector('.sgc__related').closest('.sgc__sectie').before(extra);
        }
        grid = extra.querySelector('.sgc__art-grid');
      }
      const card = el('a', 'sgc__art'); card.href = url.pathname;
      if (item.image) {
        const holder = el('div', 'sgc__art-img'), img = document.createElement('img');
        img.src = item.image; img.alt = ''; img.loading = 'lazy'; img.width = 560; img.height = 350;
        holder.append(img); card.append(holder);
      }
      card.append(el('h3', '', item.title), el('span', 'sgc__art-meta', item.minutes + ' min lezen'));
      grid.append(card); existing.add(url.pathname);
    }
    const count = root.querySelector('[data-article-count]');
    if (count) count.textContent = existing.size + ' artikelen';
    root.dataset.discovery = 'complete';
  }
  update().catch(error => { root.dataset.discovery = 'unavailable'; console.warn('Slaapgids: de geselecteerde artikelen blijven beschikbaar.', error); });
})();
